module.exports = __webpack_public_path__ + "img/Icon awesome-edit.edddf3c6.svg";